import Theme1Layout from "./theme1/ThemeLayout";
import Theme1HomeScreen from "./theme1/HomeScreen";
import Theme1CartScreen from "./theme1/CartScreen";
import Theme1CheckoutScreen from "./theme1/CheckoutScreen";
import Theme1OrderScreen from "./theme1/OrderScreen";
import Theme1PaymentScreen from "./theme1/PaymentScreen";
import Theme1SuccessScreen from "./theme1/SuccessScreen";


import Theme2Layout from "./theme2/ThemeLayout";
import Theme2HomeScreen from "./theme2/HomeScreen";
import Theme2CartScreen from "./theme2/CartScreen";
import Theme2CheckoutScreen from "./theme2/CheckoutScreen";
import Theme2OrderScreen from "./theme2/OrderScreen";
import Theme2PaymentScreen from "./theme2/PaymentScreen";
import Theme2SuccessScreen from "./theme2/SuccessScreen";


import Theme3Layout from "./theme3/ThemeLayout";
import Theme3HomeScreen from "./theme3/HomeScreen";
import Theme3CartScreen from "./theme3/CartScreen";
import Theme3CheckoutScreen from "./theme3/CheckoutScreen";
import Theme3OrderScreen from "./theme3/OrderScreen";
import Theme3PaymentScreen from "./theme3/PaymentScreen";
import Theme3SuccessScreen from "./theme3/SuccessScreen";

import Theme4Layout from "./theme4/ThemeLayout";
import Theme4HomeScreen from "./theme4/HomeScreen";
import Theme4CartScreen from "./theme4/CartScreen";
import Theme4CheckoutScreen from "./theme4/CheckoutScreen";
import Theme4OrderScreen from "./theme4/OrderScreen";
import Theme4PaymentScreen from "./theme4/PaymentScreen";
import Theme4SuccessScreen from "./theme4/SuccessScreen";

import Theme5Layout from "./theme5/ThemeLayout";
import Theme5HomeScreen from "./theme5/HomeScreen";
import Theme5CartScreen from "./theme5/CartScreen";
import Theme5CheckoutScreen from "./theme5/CheckoutScreen";
import Theme5OrderScreen from "./theme5/OrderScreen";
import Theme5PaymentScreen from "./theme5/PaymentScreen";
import Theme5SuccessScreen from "./theme5/SuccessScreen";

import Theme6Layout from "./theme6/ThemeLayout";
import Theme6HomeScreen from "./theme6/HomeScreen";
import Theme6CartScreen from "./theme6/CartScreen";
import Theme6CheckoutScreen from "./theme6/CheckoutScreen";
import Theme6OrderScreen from "./theme6/OrderScreen";
import Theme6PaymentScreen from "./theme6/PaymentScreen";
import Theme6SuccessScreen from "./theme6/SuccessScreen";

import Theme7Layout from "./theme7/ThemeLayout";
import Theme7HomeScreen from "./theme7/HomeScreen";
import Theme7CartScreen from "./theme7/CartScreen";
import Theme7CheckoutScreen from "./theme7/CheckoutScreen";
import Theme7OrderScreen from "./theme7/OrderScreen";
import Theme7PaymentScreen from "./theme7/PaymentScreen";
import Theme7SuccessScreen from "./theme7/SuccessScreen";


import Theme8Layout from "./theme8/ThemeLayout";
import Theme8HomeScreen from "./theme8/HomeScreen";
import Theme8CartScreen from "./theme8/CartScreen";
import Theme8CheckoutScreen from "./theme8/CheckoutScreen";
import Theme8OrderScreen from "./theme8/OrderScreen";
import Theme8PaymentScreen from "./theme8/PaymentScreen";
import Theme8SuccessScreen from "./theme8/SuccessScreen";

import Theme9Layout from "./theme9/ThemeLayout";
import Theme9HomeScreen from "./theme9/HomeScreen";
import Theme9CartScreen from "./theme9/CartScreen";
import Theme9CheckoutScreen from "./theme9/CheckoutScreen";
import Theme9OrderScreen from "./theme9/OrderScreen";
import Theme9PaymentScreen from "./theme9/PaymentScreen";
import Theme9SuccessScreen from "./theme9/SuccessScreen";

import Theme10Layout from "./theme10/ThemeLayout";
import Theme10HomeScreen from "./theme10/HomeScreen";
import Theme10CartScreen from "./theme10/CartScreen";
import Theme10CheckoutScreen from "./theme10/CheckoutScreen";
import Theme10OrderScreen from "./theme10/OrderScreen";
import Theme10PaymentScreen from "./theme10/PaymentScreen";
import Theme10SuccessScreen from "./theme10/SuccessScreen";



const themeConfig = {

  theme1: {
    Layout: Theme1Layout,
    HomeScreen: Theme1HomeScreen,
    CartScreen: Theme1CartScreen,
    CheckoutScreen: Theme1CheckoutScreen,
    OrderScreen: Theme1OrderScreen,
    PaymentScreen: Theme1PaymentScreen,
    SuccessScreen: Theme1SuccessScreen,
  },

  theme2: {
    Layout: Theme2Layout,
    HomeScreen: Theme2HomeScreen,
    CartScreen: Theme2CartScreen,
    CheckoutScreen: Theme2CheckoutScreen,
    OrderScreen: Theme2OrderScreen,
    PaymentScreen: Theme2PaymentScreen,
    SuccessScreen: Theme2SuccessScreen,
  },

  theme3: {
  Layout: Theme3Layout,
  HomeScreen: Theme3HomeScreen,
  CartScreen: Theme3CartScreen,
  CheckoutScreen: Theme3CheckoutScreen,
  OrderScreen: Theme3OrderScreen,
  PaymentScreen: Theme3PaymentScreen,
  SuccessScreen: Theme3SuccessScreen,
  },

  theme4: {
  Layout: Theme4Layout,
  HomeScreen: Theme4HomeScreen,
  CartScreen: Theme4CartScreen,
  CheckoutScreen: Theme4CheckoutScreen,
  OrderScreen: Theme4OrderScreen,
  PaymentScreen: Theme4PaymentScreen,
  SuccessScreen: Theme4SuccessScreen,
  },

  theme5: {
  Layout: Theme5Layout,
  HomeScreen: Theme5HomeScreen,
  CartScreen: Theme5CartScreen,
  CheckoutScreen: Theme5CheckoutScreen,
  OrderScreen: Theme5OrderScreen,
  PaymentScreen: Theme5PaymentScreen,
  SuccessScreen: Theme5SuccessScreen,
  },

  theme6: {
  Layout: Theme6Layout,
  HomeScreen: Theme6HomeScreen,
  CartScreen: Theme6CartScreen,
  CheckoutScreen: Theme6CheckoutScreen,
  OrderScreen: Theme6OrderScreen,
  PaymentScreen: Theme6PaymentScreen,
  SuccessScreen: Theme6SuccessScreen,
  },

  theme7: {
  Layout: Theme7Layout,
  HomeScreen: Theme7HomeScreen,
  CartScreen: Theme7CartScreen,
  CheckoutScreen: Theme7CheckoutScreen,
  OrderScreen: Theme7OrderScreen,
  PaymentScreen: Theme7PaymentScreen,
  SuccessScreen: Theme7SuccessScreen,
  },

  theme8: {
  Layout: Theme8Layout,
  HomeScreen: Theme8HomeScreen,
  CartScreen: Theme8CartScreen,
  CheckoutScreen: Theme8CheckoutScreen,
  OrderScreen: Theme8OrderScreen,
  PaymentScreen: Theme8PaymentScreen,
  SuccessScreen: Theme8SuccessScreen,
  },

 theme9: {
  Layout: Theme9Layout,
  HomeScreen: Theme9HomeScreen,
  CartScreen: Theme9CartScreen,
  CheckoutScreen: Theme9CheckoutScreen,
  OrderScreen: Theme9OrderScreen,
  PaymentScreen: Theme9PaymentScreen,
  SuccessScreen: Theme9SuccessScreen,
  },

  theme10: {
  Layout: Theme10Layout,
  HomeScreen: Theme10HomeScreen,
  CartScreen: Theme10CartScreen,
  CheckoutScreen: Theme10CheckoutScreen,
  OrderScreen: Theme10OrderScreen,
  PaymentScreen: Theme10PaymentScreen,
  SuccessScreen: Theme10SuccessScreen,
  },

  
};

export default themeConfig;